import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { firstValueFrom, lastValueFrom, map } from 'rxjs';
import {SaveLoaderHelper} from './save-loader-helper.service';




@Injectable({
  providedIn: 'root',
})
export class GraphqlService {
  public isQueryLoading = false;

  constructor(
    private apollo: Apollo,
    private saveLoaderHelper: SaveLoaderHelper
  ) {}

  /**
   * Execute a GraphQL query
   */
  async fetchData(
    options: {
      query: any;
      variables?: any;
    },
    fetchPolicy: any = 'network-only',
    errorPolicy: any = 'all'
  ) {
    this.isQueryLoading = true;

    try {
      const result = await lastValueFrom(
        this.apollo.query({
          query: options.query,
          variables: options.variables,
          fetchPolicy,
          errorPolicy,
        })
      );

      this.isQueryLoading = false;
      return result;
    } catch (error) {
      this.isQueryLoading = false;
      console.error('Error occurred while fetching data:', error);
      throw error;
    }
  }

  getDataFromApi(query, variables?){
    return this.apollo.query({
      query,
      variables
    }).pipe(
      map(({data})=>{
        const response = Object.values(data)[0] ;
        console.log({response});
        
        return response;
      })
    )
  }
  
  // async checkAccessTokenValidity() {
  //   setInterval(() => {
  //     let expireIn = parseInt(this.storageService.getItem('expireIn'));
  //     const currentTime = Date.now().toString();
  //
  //     let timeRemaining = (expireIn - parseInt(currentTime)) / 1000;
  //
  //
  //     if (timeRemaining <= 50 && timeRemaining > 0 && !this.isRefreshing) {
  //       this.isRefreshing = true;
  //
  //       try {
  //         const refreshToken = this.storageService.getItem('refreshToken');
  //         if (refreshToken) {
  //           this.isRefreshing = false;
  //         }
  //       } catch (error) {
  //         console.error('Token refresh error:', error);
  //         this.isRefreshing = false;
  //       }
  //     } else if (timeRemaining <= 0 && !this.isRefreshing) {
  //       const currentTime = Date.now(); // Current timestamp in ms
  //       const expireDuration = 15 * 60 * 1000; // 15 minutes = 900000 ms
  //       this.storageService.setItem('expireIn', (currentTime + expireDuration).toString());
  //     }
  //   }, 5000);
  // }
  /**
   * Execute a GraphQL mutation
   */
  async mutate(options: {
    mutation: any;
    variables?: any;
    useBlockLoader?: any;
    doNotReportError?: boolean;
  }) {
    try {
      const loader = options?.useBlockLoader;
      if (loader?.useBlockLoader) {
        this.saveLoaderHelper.setLoader({
          isLoading: true,
          loaderMessage: loader.loaderMessage ?? 'Please Wait... Saving Data',
          hasError: false,
        });
      }

      const response = await firstValueFrom(
        this.apollo.mutate({
          mutation: options.mutation,
          variables: options.variables,
        })
      );

      const mutatedEndpoint = Object.keys(response.data)[0];

      if (loader?.useBlockLoader && response.data[mutatedEndpoint]?.code === 9000) {
        this.saveLoaderHelper.setLoader({
          isLoading: false,
          loaderMessage: null,
          hasError: false,
        });
      } else if (loader?.useBlockLoader) {
        this.saveLoaderHelper.setLoader({
          isLoading: false,
          loaderMessage: response.data[mutatedEndpoint]?.message,
          hasError: true,
        });
      }

      return response;
    } catch (e) {
      if (options?.useBlockLoader?.useBlockLoader) {
        this.saveLoaderHelper.setLoader({
          isLoading: false,
          loaderMessage: e.message,
          hasError: true,
        });
      }
      throw e;
    }
  }
}
